import axios from 'axios';
import { Cookies } from 'react-cookie';
import { URL_CERBERUS } from '../../../config/keys';
import { clearStoragePreservingPreferences, setLocalStorage } from '../../../helpers/localStorage';
import { Login, LoginResult, Policy, TokenInfo, Totp, TotpApp, TotpMethod } from './model';

const cookies = new Cookies();

export function logoutUserWithoutDispatch() {
	cookies.remove('id_token', { path: '/' });
	cookies.remove('role', { path: '/' });
	cookies.remove('access_right', { path: '/' });
	cookies.remove('email', { path: '/' });
	cookies.remove('user_id', { path: '/' });
	cookies.remove('super_admin', { path: '/' });
	cookies.remove('policies', { path: '/' });
	clearStoragePreservingPreferences();
}

export async function loginUser(data: Login & { code: string }, session?: string): Promise<{ sign_in_response: LoginResult }> {
	const headers = {
		Accept: 'application/json',
		'Content-Type': 'application/json'
	};
	return await axios.post(`${URL_CERBERUS}/api/v1/sign-in?web_object_actions=true&totp=true&session=${session ?? ''}`, data, { headers }).then(res => res.data);
}

export async function getTotp(data: Login, session?: string): Promise<Totp> {
	const headers = {
		Accept: 'application/json',
		'Content-Type': 'application/json'
	};
	return await axios.post(`${URL_CERBERUS}/api/v1/sign-in?web_object_actions=true&totp=true&session=${session ?? ''}`, data, { headers }).then(res => res.data);
}

export async function setPreferredTotp(data: { login: Login, method: TotpMethod, phone?: string }): Promise<TotpApp> {
	const headers = {
		Accept: 'application/json',
		'Content-Type': 'application/json'
	};
	return await axios.post(`${URL_CERBERUS}/api/v1/totp`, data, { headers }).then(res => res.data);
}

function setPolicies(policies?: Policy, teamUsers?: number[]) {
	if (policies != null) {
		setLocalStorage('policies', { policies });
	}
	if (teamUsers != null) {
		setLocalStorage('teamUsers', teamUsers);
	}
}

async function getPoliciesAndTeamUsers(): Promise<{ policies: Policy, team_users: number[] }> {
	return axios.get(`${URL_CERBERUS}/api/v1/auth/policies-and-team-users`).then(r => r.data);
}

export async function updatePolicies() {
	const cookie = new Cookies();
	const token = cookie.get('id_token');
	axios.defaults.headers.common.Authorization = token;
	const policiesRes = await getPoliciesAndTeamUsers();

	setPolicies(policiesRes.policies, policiesRes.team_users);
}

export async function setLogin(tokenInfo: TokenInfo, policies?: Policy): Promise<Policy> {
	// if policies is undefined, fetch policies
	axios.defaults.headers.common.Authorization = `Bearer ${tokenInfo.token}`;
	const policiesRes = await getPoliciesAndTeamUsers();
	if (policies == null) {
		policies = policiesRes.policies;
	}

	setPolicies(policies, policiesRes.team_users);

	cookies.set('id_token', `Bearer ${tokenInfo.token}`, {
		path: '/'
	});
	cookies.set('intercom_token', `${tokenInfo.intercom}`, {
		path: '/'
	});
	cookies.set('user_id', `${tokenInfo.user_info.id}`, {
		path: '/'
	});
	cookies.set('company_id', `${tokenInfo.user_info.company_id}`, {
		path: '/'
	});
	cookies.set('user_intercom', `${tokenInfo.user_info.user_intercom}`, {
		path: '/'
	});
	cookies.set('email', `${tokenInfo.user_info.email}`, {
		path: '/'
	});
	// cookies.set('SessionToken', `${tokenInfo.session_token}`, {
	//     path: '/'
	// });
	cookies.set('superadmin', `${tokenInfo.superadmin}`, {
		path: '/'
	});
	const companyHiddenColumns = localStorage.getItem('company_hidden_columns');
	if (companyHiddenColumns) {
		const allStored = JSON.parse(localStorage.getItem('companies_hidden_columns') || '{}');
		allStored[tokenInfo.user_info.company_id] = JSON.parse(companyHiddenColumns);
		localStorage.setItem('companies_hidden_columns', JSON.stringify(allStored));
		localStorage.removeItem('company_hidden_columns');
	}
	const isDefaultHiddenColumns = localStorage.getItem('is_default_company_hidden_columns');
	if (isDefaultHiddenColumns) {
		const flags: Record<string, string> = JSON.parse(localStorage.getItem('companies_is_default_hidden_columns') || '{}');
		flags[tokenInfo.user_info.company_id] = 'false';
		localStorage.setItem('companies_is_default_hidden_columns', JSON.stringify(flags));
		localStorage.removeItem('is_default_company_hidden_columns');
	}
	if (tokenInfo.superadmin) {
		clearStoragePreservingPreferences();
		localStorage.setItem('visual_form_editor_advanced_mode', 'true');
	}
	return policies;
}
